<!-- eslint-disable vue/no-setup-props-destructure -->
<!-- eslint-disable no-undef -->
<script setup lang="ts">
import { ref, watch } from "vue";
import IconButton from "@/components/common-ui/buttons/IconButton.vue";
import FiloxeniaIcon from "@/components/common-ui/icons/FiloxeniaIcon.vue";

const {
  title,
  artist,
  coverUrl,
  selected = false,
} = defineProps<{
  title: string;
  artist?: string;
  coverUrl?: string;
  selected?: boolean;
}>();

const isPlaying = defineModel<boolean>("playing", {
  required: true,
});

const coverFailed = ref(false);

watch(
  () => coverUrl,
  () => {
    coverFailed.value = false;
  }
);
</script>

<template>
  <div class="list-item">
    <div>
      <img
        v-if="coverUrl && !coverFailed"
        :src="coverUrl"
        alt=""
        class="square"
        @error="coverFailed = true"
      />
      <FiloxeniaIcon v-else name="MusicNote" class="square" style="color: #ffc36e1f" />
    </div>

    <div class="title-ellipsis">
      <div class="track-title">{{ title }}</div>
      <div v-if="artist" class="track-artist">{{ artist }}</div>
    </div>

    <div class="actions">
      <IconButton @click.stop="isPlaying = !isPlaying" :inverted="selected">
        <i v-if="isPlaying" class="bi bi-pause button-icon"></i>
        <i v-else class="bi bi-play-fill button-icon"></i>
      </IconButton>
    </div>
  </div>
</template>

<style lang="scss" scoped>
$square-size: 36px;
$icon-size: 24px;

.list-item {
  display: flex;
  flex-direction: row;
  gap: 1rem;
  align-items: center;
  justify-content: space-between;
  flex-wrap: nowrap;
  width: 100%;
  height: 80px;
  padding: 0 1rem;
}

.title-ellipsis {
  flex-grow: 1;
  min-width: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.track-title {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 22px;
  font-weight: 300;
}

.track-artist {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  opacity: 0.6;
  font-size: 0.85em;
}

.square {
  width: $square-size;
  height: $square-size;
  object-fit: cover;
  border-radius: 8px;
}

.button-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: $icon-size;
  height: $icon-size;
  line-height: 1;
}
</style>
